import React from "react";

const MyProfleSection = () => {
  return (
    <div className="content-column">
      <div className="inner-column">
        <div className="list-title">
          <h3 className="title">Profile</h3>
          <div className="text">Lorem ipsum dolor sit amet, consectetur.</div>
        </div>
        <div className="gallery-sec">
          <div className="right-box-three">
            <h6 className="title">Gallery</h6>
            <div className="gallery-box">
              <div className="inner-box">
                <div className="image-box">
                  <img src="images/resource/list2-4.png" />
                  <div className="content-box">
                    <ul className="social-icon">
                      <li>
                        <a href="#">
                          <img src="images/resource/delet.svg" />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <img src="images/resource/delet1-1.svg" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="uplode-box">
                  <div className="content-box">
                    <a href="#">
                      <img src="images/resource/uplode.svg" />
                      <span>Upload</span>
                    </a>
                  </div>
                </div>
              </div>
              <div className="text">
                Max file size is 1MB, Minimum dimension: 330x300 And Suitable
                files are .jpg &amp; .png
              </div>
            </div>
          </div>
          <div className="form-sec">
            <form className="row">
              <div className="col-lg-4">
                <div className="form_boxes">
                  <label>First Name</label>
                  <input name="name" type="text" placeholder="Ali" />
                </div>
              </div>
              <div className="col-lg-4">
                <div className="form_boxes">
                  <label>Last Name</label>
                  <input name="last-name" type="text" placeholder="Tufan" />
                </div>
              </div>
              <div className="col-lg-4">
                <div className="form_boxes">
                  <label>Email</label>
                  <input
                    name="email"
                    type="email"
                    placeholder="creativelayers088@gmail.com"
                  />
                </div>
              </div>
              <div className="col-lg-4">
                <div className="form_boxes">
                  <label>Phone</label>
                  <input name="phone" type="number" placeholder={+77} />
                </div>
              </div>
              <div className="col-lg-4">
                <div className="form_boxes">
                  <label>Whatsapp</label>
                  <input name="whatsapp" type="number" placeholder={+98} />
                </div>
              </div>
              <div className="col-lg-4">
                <div className="form_boxes">
                  <label>Website</label>
                  <input
                    name="website"
                    type="text"
                    placeholder="www.creativelayers.net"
                  />
                </div>
              </div>
            </form>
          </div>
          <div className="right-box-three v2">
            <h6 className="title">Photos</h6>
            <div className="gallery-box">
              <div className="inner-box">
                <div className="image-box">
                  <img src="images/resource/list2-1.png" />
                  <div className="content-box">
                    <ul className="social-icon">
                      <li>
                        <a href="#">
                          <img src="images/resource/delet.svg" />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <img src="images/resource/delet1-1.svg" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="image-box">
                  <img src="images/resource/list2-2.png" />
                  <div className="content-box">
                    <ul className="social-icon">
                      <li>
                        <a href="#">
                          <img src="images/resource/delet.svg" />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <img src="images/resource/delet1-1.svg" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="image-box">
                  <img src="images/resource/list2-3.png" />
                  <div className="content-box">
                    <ul className="social-icon">
                      <li>
                        <a href="#">
                          <img src="images/resource/delet.svg" />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <img src="images/resource/delet1-1.svg" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="uplode-box">
                  <div className="content-box">
                    <a href="#">
                      <img src="images/resource/uplode.svg" />
                      <span>Upload</span>
                    </a>
                  </div>
                </div>
              </div>
              <div className="text">
                Max file size is 1MB, Minimum dimension: 330x300 And Suitable
                files are .jpg &amp; .png
              </div>
            </div>
          </div>
          <div className="map-sec-two">
            <div className="form-sec-two">
              <form className="row">
                <div className="col-lg-6">
                  <div className="form_boxes">
                    <label>Friendly Address</label>
                    <input type="text" name="address" placeholder="ali tufan" />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form_boxes">
                    <label>Map Location</label>
                    <input
                      type="text"
                      name="map-location"
                      placeholder="Map Location"
                    />
                  </div>
                </div>
                <div className="map-box">
                  <div className="goole-iframe">
                    <iframe src="https://maps.google.com/maps?width=100%25&height=600&hl=en&q=1%20Grafton%20Street,%20Dublin,%20Ireland+(My%20Business%20Name)&t=&z=14&ie=UTF8&iwloc=B&output=embed"></iframe>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form_boxes">
                    <label>Longitude</label>
                    <div className="drop-menu">
                      <div className="select">
                        <span>33</span>
                      </div>
                      <input type="hidden" name="gender" />
                      <ul className="dropdown" style={{ display: "none" }}>
                        <li>33</li>
                        <li>33</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form_boxes">
                    <label>Video Link</label>
                    <input type="text" name="video-link" placeholder="#" />
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="form_boxes">
                    <label>Description</label>
                    <textarea
                      name="text"
                      placeholder="Lorem Ipsum Dolar Sit Amet"
                      defaultValue={""}
                    />
                  </div>
                </div>
                <div className="form-submit">
                  <button type="submit" className="theme-btn">
                    Save Profile
                    <img src="images/arrow.svg"   />
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyProfleSection;
